import { getFilterBySearchTermFn } from "../../../core/util/search-and-sort";
import { createSelector } from "reselect";
import { getSortByFn } from "../../../core/util/utils";
import { Category } from "./category.model";
import { itemSelector, listSelector } from "../query-facade";
import { VasState } from "../../store/store-type";
import { BaseObjectFilters } from "../../store/bootstrap";
import { IPageFilter } from "../../store/queries/page-filter.interface";

export class CategoryPageFilter<T extends Category, F extends BaseObjectFilters> implements IPageFilter<T, F> {

    createSelector(itemsSelector: listSelector<T>, filterSelector: itemSelector<F>): (state: VasState) => Array<T> {

        return createSelector(
            itemsSelector,
            filterSelector,
            (items, filters) => {
                return items
                    .filter(getFilterBySearchTermFn(filters.searchTerm))
                    // sort
                    .sort(getSortByFn(filters.sortBy, filters.sortDirection, (sortBy: string, item: T) => {
                        switch (sortBy) {
                            case "title":
                                return item.title;
                            case "sequence":
                                return item.sequence;
                            default:
                                return 1;
                        }
                    }));
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/category/category.page-filter.ts